import CommentIcon from '@mui/icons-material/Comment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Button, Chip, CircularProgress, Paper, Table, TableBody, TableCell, tableCellClasses, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getObjectByIdApi, getObjectListByPropertyApi } from 'api/general';
import { getDetailSearchByMeetingIdPDFApi, getDstatusSearchListByMeetingIdPDFApi } from 'api/pdf';
import PreviewMeetingDialog from 'app/components/Dialog/PreviewMeetingDialog';
import ReportMenuGroup from 'app/components/ReportMenuGroup';
import CustomTooltip, { CustomTooltipBlack } from 'app/components/Tooltip/CustomTooltip';
import { canViewSecretFiles, getCustomLocaleDate, getCustomLocaleDateTime, getDownloadFileName, getManagementReadAllUnits, getManagementReadAllUnitsInsts, getSubjectName, getUploadFileFullPathDownload, getUserFullName, highlightText, stripHTMLTags } from 'app/utils/appHelpers';
import { DECISION_FILE, MEETINGS } from 'app/utils/constants/customConstant';
import { redColor } from 'config';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DetailSearchDataTableFilter from './DetailSearchDataTableFilter';
import DetailSearchDataTableToolbar from './DetailSearchDataTableToolbar';
import LoadingPopUp from 'app/components/LoadingPopup';
import { imageExtensions } from 'config';
import config from 'config';
import IFrameLinkDialog from 'app/components/Dialog/IFrameLinkDialog';
import { red } from '@mui/material/colors';

function DetailSearchDataTable({ mainData, column }) {

    const { authUser, isLoading, isError, isSuccess, message } = useSelector(state => state.auth)

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 12,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));


    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState(mainData);
    const [data2, setData2] = useState(mainData);
    const [previewMeetingDialogStatus, setPreviewMeetingDialogStatus] = useState(false);
    const [selectedPreviewMeeting, setSelectedPreviewMeeting] = useState(null);
    const [selectedFilters, setSelectedFilters] = useState({});
    const [loading, setLoading] = useState(false);
    const subjectList = useSelector(state => state.subject.data || []);
    const [agendaFilesMap, setAgendaFilesMap] = useState({});

    const [fileLoading, setFileLoading] = useState(false);



    useEffect(() => {
        const getAPI = async () => {
            setFileLoading(true);
            const currentPageData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
            const filesMap = {};
            for (const item of currentPageData) {
                const res = await getObjectListByPropertyApi(DECISION_FILE, "decisionId", item.id);
                filesMap[item.id] = res.data;
            }
            setAgendaFilesMap(prev => ({ ...prev, ...filesMap }));
            setFileLoading(false);
        };
        getAPI();
    }, [data, page, rowsPerPage]);

    const handlePreviewButtonClick = async (meetingId) => {
        const res = await getObjectByIdApi(MEETINGS, meetingId)
        setSelectedPreviewMeeting(res.data);
        setPreviewMeetingDialogStatus(true)
    }
    const handleRequestSort = (event, property) => {
        const tempOrderBy = property;
        let tempOrder = 'desc';

        if (orderBy === property && order === 'desc') {
            tempOrder = 'asc';
        }

        const tempdata =
            tempOrder === 'desc'
                ? data.sort((a, b) => (b[tempOrderBy] < a[tempOrderBy] ? -1 : 1))
                : data.sort((a, b) => (a[tempOrderBy] < b[tempOrderBy] ? -1 : 1));

        setData(tempdata);
        setOrder(tempOrder);
        setOrderBy(tempOrderBy);

    };
    const tableCellStyle = { fontSize: '10px' };
    const commonColumnStyle = { ...tableCellStyle, minWidth: 30, maxWidth: 50 };
    const DataTableHead = ({ onRequestSort, customColumnData }) => {
        const createSortHandler = property => event => {
            onRequestSort(event, property);
        };
        return (
            <TableHead>
                <TableRow >
                    {customColumnData.map(column => (
                        <TableCell
                            key={column.id}
                            align={column.align}
                            padding={column.disablePadding ? 'none' : 'normal'}
                            sx={{ whiteSpace: 'normal', ...column.sx }}
                        >
                            <Tooltip
                                title="Sırala"
                                placement={column.align === 'right' ? 'bottom-end' : 'bottom-start'}
                                enterDelay={300}
                            >
                                <TableSortLabel
                                    active={orderBy === column.id}
                                    direction={order}
                                    onClick={createSortHandler(column.id)}
                                    sx={{ whiteSpace: 'normal', '& .MuiTableSortLabel-icon': { flexShrink: 0 } }}
                                >
                                    {column.label}
                                </TableSortLabel>
                            </Tooltip>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    };


    const [searchType, setSearchType] = useState("toolbar");

    const handleReportClick = async () => {
        setLoading(true);
        let payload = {};
        if (searchType === "toolbar") {

            payload = {
                filters: toolbarSearchPayload,
                searchType: searchType

            }
        } else {

            payload = {
                filters: selectedFilters,
                searchType: searchType

            };

        }

        await getDetailSearchByMeetingIdPDFApi(payload);


        setLoading(false);
    };

    const openFile = async (meetingId, fileObj) => {

        const res = await getObjectByIdApi(MEETINGS, meetingId)
        const meeting = res.data;

        const filename = fileObj.id + fileObj.ext;
        let fileFolderName = "";
        if (meeting !== undefined && meeting.id !== undefined) { // previewdan geliyor demektir
            fileFolderName = "meetingFiles/" + meeting.inst + "-" + meeting.id;
        }
        const downloadName = getDownloadFileName(meeting, fileObj);
        getUploadFileFullPathDownload(fileFolderName, filename, downloadName);
    };


    const [toolbarSearchPayload, setToolbarPayload] = useState({});
    let highlightQuery = '';
    if (searchType === 'toolbar') highlightQuery = toolbarSearchPayload.searchText;
    if (searchType === 'filter') highlightQuery = selectedFilters.agendaText;
    const [dialogOpen, setDialogOpen] = useState(false);
    const [iframeUrl, setIframeUrl] = useState('');


    const handleLinkClick = (url) => {
        setIframeUrl(url);
        setDialogOpen(true);
    };



    return (
        <Paper className="col-md-12" sx={{ minWidth: 0, overflow: 'hidden' }}>

            <DetailSearchDataTableToolbar
                pageTitle={"Tüm Yetkili Olduğunuz Toplantılar"}
                type={authUser !== undefined && authUser.inst}
                setSearchType={setSearchType}
                data2={data2}
                setData={setData}
                setLoading={setLoading}
                setToolbarPayload={setToolbarPayload}
            />

            <DetailSearchDataTableFilter
                data={data2}
                setFilterData={(data) => setData(data)}
                setPage={setPage}
                setSelectedFilters={setSelectedFilters}
                loading={loading}
                setLoading={setLoading}
                type={authUser !== undefined && authUser.inst}
                setSearchType={setSearchType}
            />

            <LoadingPopUp open={loading} />
            {!loading && (

                <>

                    {data && data.length > 0 && (
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, mr: 1 }}>
                            <Tooltip title="PDF Raporunu oluştur">
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={() => handleReportClick(data)}
                                >
                                    Rapor Oluştur
                                </Button>
                            </Tooltip>
                        </Box>
                    )}


                    {Object.keys(selectedFilters).length > 0 && (
                        <div style={{ margin: '10px', display: 'flex', flexWrap: 'wrap' }}>
                            {Object.entries(selectedFilters).map(([key, value]) => {
                                if (
                                    value === null ||
                                    (Array.isArray(value) && value.length === 0) ||
                                    value === ""
                                )
                                    return null;
                                if (key === "pageType") {
                                    return null;
                                }
                                if (key === "statFinish") {
                                    return value === 1 ? (
                                        <Chip
                                            key={key}
                                            label="Tamamlanan Toplantılar"
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    ) : null;
                                }
                                if (key === "applied") {
                                    return value ? (
                                        <Chip
                                            key={key}
                                            label="Uygulananlar"
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    ) : null;
                                }
                                if (key === "notApplied") {
                                    return value ? (
                                        <Chip
                                            key={key}
                                            label="Uygulanmayanlar"
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    ) : null;
                                }
                                if (["principle", "supp", "secret"].includes(key)) {
                                    const mapping = {
                                        principle: "İlke Kararı",
                                        supp: "Ek Gündem",
                                        secret: "Gizli"
                                    };
                                    return value === 1 ? (
                                        <Chip
                                            key={key}
                                            label={mapping[key]}
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    ) : null;
                                }
                                const combinedFields = [
                                    "meetingInst",
                                    "decisionDepartments",
                                    "decisionSubjectIds",
                                    "meetingUnitIds",
                                    "meetingAdminUserIds",
                                    "meetingCreatorUserIds",
                                    "meetingParticipantUserIds",
                                    "statusReviewUserIds"
                                ];
                                if (Array.isArray(value) && combinedFields.includes(key)) {
                                    let chipLabel = "";
                                    if (key === "meetingInst") {
                                        chipLabel = "Kurum: " + value.join(", ");
                                    } else if (key === "decisionDepartments") {
                                        chipLabel = "İlgili Kurum/Birim: " + value.join(", ");
                                    } else if (key === "decisionSubjectIds") {
                                        const labels = value.map(item => item.name || item);
                                        chipLabel = "Konu: " + labels.join(", ");
                                    } else if (key === "meetingUnitIds") {
                                        const labels = value.map(item => item.name);
                                        chipLabel = "Kurul/Kol/Komisyon: " + labels.join(", ");
                                    } else if (["meetingAdminUserIds", "meetingCreatorUserIds", "meetingParticipantUserIds", "statusReviewUserIds"].includes(key)) {
                                        const userKeyMapping = {
                                            meetingAdminUserIds: "Toplantı Yöneticisi",
                                            meetingCreatorUserIds: "Üyeler",
                                            meetingParticipantUserIds: "Katılımcılar",
                                            statusReviewUserIds: "Uygulama Durumu Güncelleyenler"
                                        };
                                        const labels = value.map(item => getUserFullName(item) || item);
                                        chipLabel = `${userKeyMapping[key]}: ${labels.join(", ")}`;
                                    } else {
                                        chipLabel = `${key}: ${value.join(", ")}`;
                                    }
                                    return (
                                        <Chip
                                            key={key}
                                            label={chipLabel}
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    );
                                }
                                if (typeof value === "string") {
                                    const stringLabelMapping = {
                                        agendaText: "Gündem/Karar",
                                        // decisionText: "Karar",
                                        meetingNo: "Toplantı Sayı"
                                    };
                                    const labelPrefix = stringLabelMapping[key] || key;
                                    return (
                                        <Chip
                                            key={key}
                                            label={`${labelPrefix}: ${value}`}
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    );
                                }
                                if (value && value.format) {
                                    const dateLabelMapping = {
                                        pdateStart: "Başlangıç Tarihi",
                                        pdateEnd: "Bitiş Tarihi"
                                    };
                                    const labelPrefix = dateLabelMapping[key] || key;
                                    return (
                                        <Chip
                                            key={key}
                                            label={`${labelPrefix}: ${value.format("DD/MM/YYYY")}`}
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    );
                                }
                                return null;
                            })}
                        </div>
                    )}

                    <div className="flex-auto" style={{ minWidth: 0 }}>
                        <Box sx={{ overflowX: 'auto' }}>
                            <Table
                                size="small"
                                aria-label="customized table"
                                sx={{
                                    minWidth: 960,
                                    '& .MuiTableCell-head': { whiteSpace: 'normal' },
                                    '& .MuiTableSortLabel-root': { whiteSpace: 'normal' },
                                    '& .MuiTableSortLabel-icon': { flexShrink: 0 },
                                }}
                            >

                                <DataTableHead
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={data.length}
                                    customColumnData={column}
                                />

                                <TableBody>
                                    {data
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((n) => {
                                            const agendaFiles = agendaFilesMap[n.id] || [];
                                            return (
                                                <StyledTableRow hover key={"trO" + n.id}>
                                                    <StyledTableCell align="left" padding="normal" sx={{ ...tableCellStyle, minWidth: 80, maxWidth: 100 }}>
                                                        <Typography variant="caption" style={{ display: 'block', ...tableCellStyle }}>
                                                            {n.inst} {n.unit} / {n.meetingNo}
                                                        </Typography>
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center" padding="normal" sx={commonColumnStyle}>
                                                        {n.meetingDate ? getCustomLocaleDate('tr', n.meetingDate) : ""}
                                                        {n.meetingDate ? <div>{getCustomLocaleDateTime('tr', n.meetingDate)}</div> : ""}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center" padding="normal" sx={commonColumnStyle}>
                                                        {n.decisionNo}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center" padding="normal" sx={commonColumnStyle}>
                                                        {n.department}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" padding="normal" sx={{ ...tableCellStyle, maxWidth: 70 }}>
                                                        {getSubjectName(n.subjectId, subjectList)}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" padding="normal" sx={{ ...tableCellStyle, minWidth: 200, maxWidth: 350, whiteSpace: 'pre-line' }}>
                                                        {highlightText(stripHTMLTags(n.agenda), highlightQuery)}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" padding="normal" sx={{ ...tableCellStyle, minWidth: 200, maxWidth: 350, whiteSpace: 'pre-line' }}>
                                                        {highlightText(stripHTMLTags(n.decision), highlightQuery)}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" padding="none">
                                                        {fileLoading ? <CircularProgress size={20} /> :
                                                            agendaFiles && agendaFiles.length > 0 ? (
                                                                canViewSecretFiles(n, authUser) ? (
                                                                    agendaFiles.map((item, index) => {
                                                                        const isImage = imageExtensions.includes(item.ext.toLowerCase());
                                                                        const fileUrl = config.apiUrl + "/uploads" + "/" + `meetingFiles/${n.inst}-${n.meetingId}/${item.id}${item.ext}`;
                                                                        const displayFileType = item.fileInfo ? "Bağlantı: " + item.fileType : item.fileType + item.ext;
                                                                        const linkUrl = item.fileInfo ? item.fileInfo : fileUrl;

                                                                        return (
                                                                            <div key={item.id}>
                                                                                <span style={{
                                                                                    color: redColor,
                                                                                    textDecoration: item.fileInfo ? "underline" : "none"
                                                                                }}>
                                                                                    EK-{index + 1}:
                                                                                </span>
                                                                                <CustomTooltip
                                                                                    title={
                                                                                        isImage && !item.fileInfo ? (
                                                                                            <img
                                                                                                src={fileUrl}
                                                                                                alt="Preview"
                                                                                                style={{
                                                                                                    maxWidth: '500px',
                                                                                                    maxHeight: '500px',
                                                                                                    objectFit: 'contain',
                                                                                                    backgroundColor: 'white',
                                                                                                    padding: '8px'
                                                                                                }}
                                                                                            />
                                                                                        ) : ''
                                                                                    }
                                                                                    placement="right"
                                                                                    arrow
                                                                                    sx={{
                                                                                        '& .MuiTooltip-tooltip': {
                                                                                            padding: '8px',
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <a
                                                                                        href="#"
                                                                                        style={{
                                                                                            textDecoration: item.fileInfo ? "underline" : "none",
                                                                                            color: redColor,
                                                                                            fontWeight: "400",
                                                                                        }}
                                                                                        onMouseEnter={(e) => {
                                                                                            e.target.style.color = '#b71c1c';
                                                                                        }}
                                                                                        onMouseLeave={(e) => {
                                                                                            e.target.style.color = redColor;
                                                                                        }}
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            if (item.fileInfo) {
                                                                                                handleLinkClick(linkUrl);
                                                                                            } else {
                                                                                                openFile(n.meetingId, item);
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {displayFileType}
                                                                                    </a>
                                                                                </CustomTooltip>
                                                                            </div>
                                                                        );
                                                                    })
                                                                ) : (
                                                                    <span style={{ color: 'gray', fontStyle: 'italic' }}>
                                                                        Gizli dosyalar - Yetkiniz bulunmamaktadır
                                                                    </span>
                                                                )
                                                            ) : "Ekli Dosya Bulunamadı"}
                                                    </StyledTableCell>
                                                    <StyledTableCell
                                                        align="right"
                                                        padding="none"
                                                        sx={{ ...tableCellStyle, minWidth: 50, maxWidth: 50 }}
                                                    >
                                                        <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                                                            <CustomTooltipBlack
                                                                placement="top-start"
                                                                arrow
                                                                title={
                                                                    <div>
                                                                        <Typography variant="caption" style={{ display: 'block', fontSize: '10px' }}>
                                                                            İlke Kararı : {n.principle}
                                                                        </Typography>
                                                                        <Typography variant="caption" style={{ display: 'block', fontSize: '10px' }}>
                                                                            Ek Gündem : {n.supp}
                                                                        </Typography>
                                                                        <Typography variant="caption" style={{ display: 'block', fontSize: '10px' }}>
                                                                            Gizli : {n.secret}
                                                                        </Typography>
                                                                        <Typography variant="caption" style={{ display: 'block', fontSize: '10px' }}>
                                                                            Tamamlanmış Mı? : {n.statFinish === 1 ? 'Evet' : 'Hayır'}
                                                                        </Typography>
                                                                    </div>
                                                                }
                                                            >
                                                                <CommentIcon fontSize="small" style={{ verticalAlign: 'middle' }} />
                                                            </CustomTooltipBlack>
                                                            <Tooltip title="Raporlar">
                                                                <ReportMenuGroup meeting={n} decisionId={n.id} type="agenda" fromPage={"detail"} />
                                                            </Tooltip>
                                                            <Tooltip title="Toplantı Bilgi Önizleme">

                                                                <VisibilityIcon

                                                                    color="primary"
                                                                    onClick={async () => {
                                                                        await handlePreviewButtonClick(n.meetingId);
                                                                    }}

                                                                    fontSize="small" style={{ verticalAlign: 'middle' }} />

                                                            </Tooltip>
                                                        </Box>
                                                    </StyledTableCell>

                                                </StyledTableRow>
                                            );
                                        })}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            count={data.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={(e, page) => setPage(page)}
                                            onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
                                            labelRowsPerPage={"Görüntülenecek Satır"}
                                            rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                                            showFirstButton
                                            showLastButton
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </Box>
                    </div>
                    <PreviewMeetingDialog
                        meeting={selectedPreviewMeeting}
                        onClose={() => setPreviewMeetingDialogStatus(false)}
                        open={previewMeetingDialogStatus}
                    />

                    {dialogOpen && (
                        <IFrameLinkDialog
                            open={dialogOpen}
                            onClose={() => setDialogOpen(false)}
                            iframeUrl={iframeUrl}
                        />

                    )}

                </>
            )
            }
        </Paper >
    );
};

export default DetailSearchDataTable;